import type { FunctionComponent } from 'react';
import { Suspense } from 'react';

import {
  ChunkLoadErrorBoundary,
  ErrorBoundary,
} from '@trello/error-boundaries';
import { useLazyComponent } from '@trello/use-lazy-component';

import type { BoardDisplayAdsContainerProps } from './BoardDisplayAdsContainer';

export const LazyBoardDisplayAdsContainer: FunctionComponent<
  BoardDisplayAdsContainerProps
> = (props) => {
  const BoardDisplayAdsEnrollmentLayer = useLazyComponent(
    () =>
      import(
        /* webpackChunkName: "board-display-ads-enrollment-layer" */ './BoardDisplayAdsEnrollmentLayer'
      ),
    { namedImport: 'BoardDisplayAdsEnrollmentLayer' },
  );

  return (
    <ErrorBoundary
      tags={{ ownershipArea: 'trello-web-eng', feature: 'Board Display Ads' }}
    >
      <ChunkLoadErrorBoundary fallback={null}>
        <Suspense fallback={null}>
          <BoardDisplayAdsEnrollmentLayer {...props} />
        </Suspense>
      </ChunkLoadErrorBoundary>
    </ErrorBoundary>
  );
};
